import { createContext, useCallback, useContext } from 'react';
import { resolveMentoringTarget } from './mentoringContent';

/**
 * The locale of the mentoring section is path-authoritative (`/fr/mentorat`
 * vs `/en/mentoring`), never sniffed from the browser. MentoringRoute
 * provides it so every component builds links in the language being read.
 */
export const MentoringLocaleContext = createContext('fr');

export const useMentoringLocale = () => useContext(MentoringLocaleContext);

/** Resolves a content `target` key to an href in the current locale. */
export const useMentoringHref = () => {
  const locale = useMentoringLocale();

  return useCallback(
    (action) => resolveMentoringTarget(action?.target, locale),
    [locale],
  );
};
